import React, { useState } from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import { ReactComponent as SearchIcon } from "../Assets/Icons/search.svg";
import AiTeamDropDown from "../Components/AiTeamDropDown";
import AiProjectCard from "../Components/AiProjectCard";
import ProjectImg from "../Assets/ProjectImg.png";
import ProjectImgOne from "../Assets/ProjectImg1.png";
import AllAiProjectsSideBar from "../Components/AllAiProjectsSideBar";
import MatchhingModal from "../Components/MatchingModal";

export default function AllAIProjects() {
  const [openModal, setOpenModal] = useState(false);
  const [matchOpen, setMatchOpen] = useState(false);
  return (
    <div style={{ position: openModal ? "fixed" : "static" }}>
      <DashboardLayout>
        <section className="bg-white pl-6 py-4 gap-y-5 w-full flex flex-col items-start">
          {openModal && (
            <div className="absolute z-20 top-0 left-0 w-full h-screen overflow-hidden bg-black bg-opacity-75">
              <AllAiProjectsSideBar
                setOpenModal={setOpenModal}
                handleSubmit={() => setMatchOpen(true)}
              />
            </div>
          )}
          <Breadcrumbs links={[{ name: "AI Projects", link: "dsads" }]} />
          <h1 className="text-xl font-semibold">All AI Projects</h1>
          <div className="flex items-center gap-6">
            <div className="flex items-center ">
              <div className="rounded-l-lg border flex items-center py-2 px-3 bg-[#F9FAFB] w-[22rem]">
                <SearchIcon />
                <input
                  type="text"
                  placeholder="Search AI Projects"
                  className="border-none ml-2 bg-inherit w-full text-sm font-medium text-[#6B7280] focus:outline-none"
                />
              </div>
              <div>
                <button className="w-[4.4rem] py-2 px-2 text-[0.95rem] font-[500] text-white rounded-r-lg bg-[#942A27]">
                  Search
                </button>
              </div>
            </div>
            <AiTeamDropDown
              text="Status"
              width="8.75rem"
              options={["Not Assigned", "In Progress", "Completed", "All"]}
            />
            <AiTeamDropDown
              text="Stage"
              width="8.75rem"
              options={["Ideation", "Exploration", "Development", "Deployment"]}
            />
            {/* <AiTeamDropDown text="Department" width="8.75rem" /> */}
            <AiTeamDropDown
              text="Beneficiary"
              width="12rem"
              options={[
                "Executive Management",
                "Exploration and Production",
                "Refining, Marketing, and Distribution",
                "Research and Development (R&D)",
                "Human Resources",
                "Finance and Accounting",
                "Information Technology",
                "Legal and Compliance",
                "Corporate Affairs / Public Relations",
                "Supply Chain and Procurement",
                "Health, Safety, and Environment (HSE)",
                "Corporate Strategy and Business Development",
                "Upstream",
                "Midstream",
                "Downstream",
                "Aramco Digital Co",
                "Explorium",
                "Refinery",
                "Other     ",
              ]?.sort()}
            />
            {/* <AiTeamDropDown text="Project Lead" width="8.75rem" /> */}
          </div>
        </section>
        <section className="bg-[#f9fafb] w-full pt-6 px-6 pb-8">
          {/* <AllAiProjectsSideBar /> */}
          <MatchhingModal open={matchOpen} setOpen={setMatchOpen} />
          <div>
            <p className="text-[1rem] font-bold text-[#6B7280]">
              Showing : <span className="text-[#111928]"> 1,356,546</span>
            </p>
            <div className="flex items-center flex-col gap-3 mt-6">
              <AiProjectCard
                projectimg={ProjectImg}
                projecttitle="Project Title"
                location="Riyadh"
                desc="Lorem ipsum dolor sit amet consectetur. Imperdiet a sed arcu nunc dolor sed nisi id aenean. "
                teamimg={ProjectImg}
                teamname="Team Name or Not Assigned"
                duetime="21h 31m"
                handleClick={() => setOpenModal(true)}
              />
              <AiProjectCard
                projectimg={ProjectImgOne}
                projecttitle="Project Title"
                location="Riyadh"
                desc="Lorem ipsum dolor sit amet consectetur. Imperdiet a sed arcu nunc dolor sed nisi id aenean. "
                teamimg={ProjectImg}
                teamname="Team Name or Not Assigned"
                duetime="21h 31m"
                handleClick={() => setOpenModal(true)}
              />
              <AiProjectCard
                projectimg={ProjectImg}
                projecttitle="Project Title"
                location="Riyadh"
                desc="Lorem ipsum dolor sit amet consectetur. Imperdiet a sed arcu nunc dolor sed nisi id aenean. "
                teamimg={ProjectImg}
                teamname="Team Name or Not Assigned"
                duetime="21h 31m"
                handleClick={() => setOpenModal(true)}
              />
              <AiProjectCard
                projectimg={ProjectImgOne}
                projecttitle="Project Title"
                location="Riyadh"
                desc="Lorem ipsum dolor sit amet consectetur. Imperdiet a sed arcu nunc dolor sed nisi id aenean. "
                teamimg={ProjectImg}
                teamname="Team Name or Not Assigned"
                duetime="21h 31m"
                handleClick={() => setOpenModal(true)}
              />
              <AiProjectCard
                projectimg={ProjectImg}
                projecttitle="Project Title"
                location="Riyadh"
                desc="Lorem ipsum dolor sit amet consectetur. Imperdiet a sed arcu nunc dolor sed nisi id aenean. "
                teamimg={ProjectImg}
                teamname="Team Name or Not Assigned"
                duetime="21h 31m"
                handleClick={() => setOpenModal(true)}
              />
              <AiProjectCard
                projectimg={ProjectImgOne}
                projecttitle="Project Title"
                location="Riyadh"
                desc="Lorem ipsum dolor sit amet consectetur. Imperdiet a sed arcu nunc dolor sed nisi id aenean. "
                teamimg={ProjectImg}
                teamname="Team Name or Not Assigned"
                duetime="21h 31m"
                handleClick={() => setOpenModal(true)}
              />
              <AiProjectCard
                projectimg={ProjectImg}
                projecttitle="Project Title"
                location="Riyadh"
                desc="Lorem ipsum dolor sit amet consectetur. Imperdiet a sed arcu nunc dolor sed nisi id aenean. "
                teamimg={ProjectImg}
                teamname="Team Name or Not Assigned"
                duetime="21h 31m"
                handleClick={() => setOpenModal(true)}
              />
            </div>
            <div className="flex items-center justify-center mt-8">
              <button className="w-[6.9rem] py-2 border-[1px] border-[#E5E7EB] rounded-[8px] text-[0.95rem] font-[500] text-[#1F2A37]">
                Load more
              </button>
            </div>
          </div>
        </section>
      </DashboardLayout>
    </div>
  );
}
